import * as bootstrap from "sard_core/vendor/assets/bootstrap/javascripts/bootstrap"

Ready(() => {
  // add content if any html popovers found
  const htmlPopoverTriggerList = document.querySelectorAll('.html-popover')
  const htmlPopoverList = [...htmlPopoverTriggerList].map(htmlPopoverTriggerEl => {
    const contentElement = htmlPopoverTriggerEl.nextElementSibling // Get the next sibling
    if (contentElement?.classList.contains('html-popover-content')) {
      htmlPopoverTriggerEl.setAttribute('data-bs-content', contentElement.innerHTML)
    }
  })

  const popoverTriggerList = [...htmlPopoverTriggerList, ...document.querySelectorAll('[data-bs-toggle="popover"]')]
  const popoverList = [...popoverTriggerList].map(popoverTriggerEl => {
    let config = { html: true, sanitize: false }
    if (popoverTriggerEl.classList?.contains('html-popover')) {
      config.sanitize = false
      config.container = popoverTriggerEl.parentElement
    }
    return new bootstrap.Popover(popoverTriggerEl, config)
  })

  const disposePopovers = () => {
    popoverList.forEach(popover => {
      if (popover?._element) {
        popover.dispose()
      }
    })
  }

  window.addEventListener("beforeunload", disposePopovers)
  document.addEventListener("turbo:before-visit", disposePopovers)
})
